<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="{ path: 'message.title_add_object', args: { objectName: linkDescription } }">
                </div>
                <hr class="dialog-hr">
                <el-form label-width="200px" @submit.native.prevent="saveLinkTenant()">
                    <div class="confirm-body">
                            <el-form-item prop="tenantName" ref="tenantName">
                                <div slot="label" style="text-align:left" v-t="'message.item_tenant_name'"></div>
                                <el-input id="tenantName" v-model="inputForm.tenantName.value" type="text"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <div v-if="this.inputForm.linkType" v-t="'message.info_allow_request_note'">
                            </div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="disableSave" native-type="submit" v-t="'message.button_save'"></el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "../../../ServerApi.js";
import charactercheck from '../../../charactercheck.js';
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import commonValidate from '../../../common-validate.js';

export default {
    data() {
        return {
            disableSave: true,
            linkDescription: null,
            inputForm: {
                tenantName: { validationRule: "domainName", value: null, isComposing: false },
                linkType: 0,
            },
        };
    },
    created: function() {
        this.inputForm.linkType = this.linkType;
        if (this.linkType == constants.TENANT_CONNECT_WANT) {
            this.linkDescription = commonUtil.getMessageText(this.$i18n,'title_desc_link_tenant1');
        } else {
            this.linkDescription = commonUtil.getMessageText(this.$i18n,'title_desc_link_tenant2');
        }
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                if (this.inputForm[eventTargetId].value == this.appData.tenantList[0].name) {
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_cannot_use_own_tenant");
                    this.disableSave = true;
                } else {
                    this.$refs[eventTargetId].clearValidate();
                    this.disableSave = false;
                }
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableSave = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        saveLinkTenant() {
            let self = this;
            server.postNoError('/checktenantname', {
                tenantName: self.inputForm.tenantName.value
            })
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_ERROR_NOT_FOUND:
                        this.disableSave = true;
                        self.$refs["tenantName"].validateMessage = commonUtil.getMessageText(this.$i18n,"error_link_not_found");
                        self.$refs["tenantName"].validateState ="error";
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        self.$emit('save', self.inputForm.linkType, self.inputForm.tenantName.value, 0);
                        break;
                    default:
                        self.$refs["tenantName"].validateMessage = commonUtil.getMessageText(this.$i18n,"error_link_api_error").replace('{status}',res.data.status);
                        self.$refs["tenantName"].validateState ="error";
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "saveLinkTenant", error);
            });
        },
    },
    props: [ 'appData' , 'linkType' ]
}
</script scoped>

<style scoped>
.setting-items {
    padding-top: 10px;
}

.setting-items >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #5171cb;
    border: #5171cb;
}

.setting-items >>> .el-slider__bar {
    background-color: #5171cb;
}
</style>
